import { AnalyticAuth } from '../types/AnalyticAuth';

export const analyticAuth: AnalyticAuth = {
  dev: {
    googleTagManagerAuth: {
      auth: 'YmGMxVAiACUK6N65X918nw',
      containerId: 'GTM-WG66XZF',
      preview: 'env-5',
    },
  },
  prod: {
    googleTagManagerAuth: {
      containerId: 'GTM-WG66XZF',
    },
  },
  qa: {
    googleTagManagerAuth: {
      auth: 'YmGMxVAiACUK6N65X918nw',
      containerId: 'GTM-WG66XZF',
      preview: 'env-5',
    },
  },
  stg: {
    googleTagManagerAuth: {
      auth: 'Fi73Yii0y8UzwsvEv1zFQg',
      containerId: 'GTM-WG66XZF',
      preview: 'env-4',
    },
  },
};
